import { createPortal } from 'react-dom';
import { Loader2, X } from 'lucide-react';

interface Props {
  title: string; message: string; confirmLabel?: string;
  isDestructive?: boolean; isLoading?: boolean; error?: string;
  onConfirm: () => void; onCancel: () => void;
}

export function ConfirmDialog({
  title, message, confirmLabel = 'Confirm',
  isDestructive = false, isLoading = false, error, onConfirm, onCancel,
}: Props): JSX.Element {
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.5)' }} onClick={onCancel} />
      <div
        className="relative rounded-lg border shadow-xl w-full max-w-sm mx-4 p-6"
        style={{ background: 'var(--bg-panel)', borderColor: 'var(--border)' }}
      >
        <div className="flex items-start justify-between mb-3">
          <h3 className="text-sm font-semibold" style={{ color: 'var(--text-1)' }}>{title}</h3>
          <button onClick={onCancel} className="opacity-40 hover:opacity-100 transition-opacity" style={{ color: 'var(--text-2)' }}>
            <X size={14} />
          </button>
        </div>
        <p className="text-sm mb-5" style={{ color: 'var(--text-2)' }}>{message}</p>

        {error && (
          <div className="rounded p-2 text-xs mb-4" style={{ background: 'var(--red-dim)', color: 'var(--red)' }}>
            {error}
          </div>
        )}

        <div className="flex items-center justify-end gap-2">
          <button
            onClick={onCancel}
            className="px-3 py-1.5 text-xs rounded border transition-opacity hover:opacity-80"
            style={{ borderColor: 'var(--border)', color: 'var(--text-2)' }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs rounded transition-opacity disabled:opacity-40 hover:opacity-80"
            style={{ background: isDestructive ? 'var(--red)' : 'var(--accent)', color: '#fff' }}
          >
            {isLoading && <Loader2 size={11} className="animate-spin" />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
